export const appRoutes: any = {
    main: {
        search: "/",
        about: "/about",
        campaigns: "/campaigns",
        campaignDetail: "/campaigns/:slug",
        career: "/career",
        privacyPolicy: "/privacy-policy",
        eysPolicy: "/eys-policy",
        serviceUsage: "/service-usage",
        services: {
            vipTransfer: "/services/vip-transfer",
            limousine: "/services/limousine",
            vito: "/services/vito",
            bus: "/services/bus",
            minibus: "/services/minibus",
            cyprus: "/services/cyprus",
            airportTransfer: "/services/airport-transfer",
            airportTransferSlug: "/services/airport-transfer/:slug",
            airportTransferDetail: (slug: string) => `/services/airport-transfer/${slug}`,
            airports: {
                IST: "/services/airport-transfer/istanbul-istanbul-airport",
                SAW: "/services/airport-transfer/istanbul-sabiha-gokcen",
                AYT: "/services/airport-transfer/antalya-airport",
                ADB: "/services/airport-transfer/izmir-adnan-menderes",
                ESB: "/services/airport-transfer/ankara-esenboga",
                DLM: "/services/airport-transfer/mugla-dalaman",
                BJV: "/services/airport-transfer/mugla-bodrum-milas",
                ASR: "/services/airport-transfer/kayseri-erkilet",
                TZX: "/services/airport-transfer/trabzon-airport",
                ADA: "/services/airport-transfer/adana-sakirpasa"
            }
        },
        corp: {
            about: "/corporate/about",

            fleet: "/corporate/fleet",
            career: "/corporate/career",
        },
        kvkk: "/kvkk",
        passengerInfo: "/passenger-info",
    },
    admin: {
        home: "/admin/home",
        templateRequest: {
            list: "/admin/template-request",
        },
        ctripChat: {
            list: "/admin/ctrip-chat",
        },
        ctripSupplyOrderList: {
            list: "/admin/ctrip-supply-order-list",
        },
        auth: {
            login: "/admin/login"
        },
        vehicle: {
            search: {
                list: "/admin/vehicle/search",
                detail: "/admin/vehicle/:id",
            },
            brand: {
                list: "/admin/vehicle/brand",
                detail: "/admin/vehicle/brand/:id",
            },
            type: {
                list: "/admin/vehicle/type",
            },
        },
        live: {
            list: "/admin/live"
        },
        tariffs: {
            b2b: {
                list: "/admin/tariffs/b2b",
            },
            normal: {
                list: "/admin/tariffs/normal",
            }
        },
        user: {
            drivers: {
                list: "/admin/user/drivers",
                detail: "/admin/user/drivers/:id",
            },
            passengers: {
                list: "/admin/user/passengers",
                detail: "/admin/user/passengers/:id",
            }
        },
        firms: {
            list: "/admin/firms",
            detail: "/admin/firm/:id",

        },
        agent: {
            list: "/admin/agent",
            detail: "/admin/agent/:id",
        },
        trip: {
            list: "/admin/trip",
            detail: "/admin/trip/detail/:id",
            comment: {
                list: `/admin/trip/comment`,
            },
        },
        b2bTrip: {
            list: `/admin/trip-b2b`,
            detail: "/admin/trip-b2b/detail/:id"
        },
        sharedTrip: {
            list: `/admin/trip-shared`,
            detail: "/admin/trip-shared/detail/:id"
        },
        driverTrip: {
            list: `/admin/trip-driver`,
            detail: "/admin/trip-driver/detail/:id"
        },
        uetdsTrip: {
            list: `/admin/trip-uetds`,
            detail: "/admin/trip-uetds/detail/:id"
        },
        call: {
            passenger: {
                list: "/admin/call/passenger",
                detail: "/admin/call/passenger/:id"
            },
            vehicle: {
                list: "/admin/call/vehicle",
            }
        },
        request: {
            list: "/admin/request",
            detail: "/admin/request/:id"
        },
        offer: {
            list: "/admin/offer",
            detail: "/admin/offer/:id"
        },
        coupon: {
            list: "/admin/coupon",
        },
        tag: {
            list: "/admin/tag",
        },
        job: {
            list: "/admin/job",
        },
        setting: {
            list: "/admin/setting",
        },
        sovos: {
            list: "/admin/sovos",
        },
        reports: {
            list: "/admin/reports",
        },
        blockedUsers: {
            list: "/admin/blocked-users",
        },
        package: {
            b2b: {
                rental: {
                    list: "/admin/package/b2b/rental",
                },
                additional: {
                    list: "/admin/package/b2b/additional",
                }
            }
        },
        invoice: {
            list: "/admin/invoice",
            detail: "/admin/invoice/:id"
        },
        route: {
            list: "/admin/route",
            detail: "/admin/route/:id",
            create: "/admin/route/create"
        },
        statistic: {
            list: "/admin/statistic",
        },
        feedback: {
            list: `/admin/feedback`,
            detail: "/admin/feedback/detail/:id"
        },
        airportGreeter: {
            greeter: {
                list: "/admin/airport-greeter/greeters",
                detail: "/admin/airport-greeter/greeters/:id",
            },
            region: {
                list: "/admin/airport-greeter/regions",
            },
        },
    },
    agent: {
        main: "/agent",
        home: "/agent/home",
        auth: {
            login: "/agent/login"
        },
        trip: {
            list: "/agent/trip",
            detail: "/agent/trip/detail/:id"
        },
        sharedTrip: {
            list: `/agent/trip-shared`,
            detail: "/agent/trip-shared/detail/:id"
        },
        profile: "/agent/profile",
        statistic: {
            list: "/agent/statistic",
        },
        invoice: {
            list: "/agent/invoice",
            detail: "/agent/invoice/:id"
        },

    },
    firm: {
        home: "/firm/home",
        auth: {
            login: "/firm/login"
        },
        trip: {
            list: "/firm/trip",
            detail: "/firm/trip/detail/:id"
        },
        uetdsTrip: {
            list: `/firm/trip-uetds`,
            detail: "/firm/trip-uetds/detail/:id"
        },
        request: {
            list: "/firm/request",
            detail: "/firm/request/:id"
        },
        drivers: {
            list: "/firm/drivers",
            detail: "/firm/drivers/:id",
            create: "/firm/drivers/create"
        },
        vehicle: {
            list: "/firm/vehicle",
            detail: "/firm/vehicle/:id",
            create: "/firm/vehicle/create"
        },
        offer: {
            list: "/firm/offer"
        },
    },
    passenger: {
        home: "/passenger/home",
        auth: {
            login: "/passenger/login"
        },
        trip: {
            list: "/passenger/trip",
            detail: "/passenger/trip/detail/:id"
        }
    },
    countryAdmin: {
        home: "/country-admin/home",
        auth: {
            login: "/country-admin/login"
        },
        trip: {
            list: "/country-admin/trip",
            detail: "/country-admin/trip/detail/:id"
        },
        b2bTrip: {
            list: `/country-admin/trip-b2b`,
            detail: "/country-admin/trip-b2b/detail/:id"
        },
        sharedTrip: {
            list: `/country-admin/trip-shared`,
            detail: "/country-admin/trip-shared/detail/:id"
        },
        driverTrip: {
            list: `/country-admin/trip-driver`,
            detail: "/country-admin/trip-driver/detail/:id"
        },
        request: {
            list: "/country-admin/request",
            detail: "/country-admin/request/:id"
        },
        user: {
            drivers: {
                list: "/country-admin/user/drivers",
                detail: "/country-admin/user/drivers/:id",
            }
        },
        firms: {
            list: "/country-admin/firms",
            detail: "/country-admin/firm/:id",

        },
        call: {
            passenger: {
                list: "/country-admin/call/passenger",
                detail: "/country-admin/call/passenger/:id"
            }
        },
        statistic: {
            list: "/country-admin/statistic",
        },
    },
    airportGreeter: {
        home: "/airport-greeter/home",
        auth: {
            login: "/airport-greeter/login"
        },
        trip: {
            list: "/airport-greeter/trips"
        }
    }
}